import calculateScaleAndDim from "./calculateScaleAndDim";

export default function calcCanvasNewSize(INITIAL_WIDTH, INITIAL_HEIGHT) {
  let iWidth = window.innerWidth;
  let iHeight = window.innerHeight;

  const { width, height } = checkConDim();
  if (width && height) {
    iWidth = width;
    iHeight = height;
  }
  const dims = calculateScaleAndDim(INITIAL_WIDTH, INITIAL_HEIGHT, iWidth, iHeight);

  let dimsAndScale = {
    WIDTH: dims.width,
    HEIGHT: dims.height,
    SCALE: dims.scale
  }
  return dimsAndScale
}

function checkConDim() {
  const params = new URLSearchParams(window.location.search);
  const width = Number(params.get("width"));
  const height = Number(params.get("height"));
  return { width, height }
}